import { Action } from '@ngrx/store';
import { Error, ErrorOptions } from '../models/error';

export const ADD_ERROR = '[Error] ADD ERROR';
export const REMOVE_ERROR = '[Error] REMOVE ERROR';
export const REMOVE_ERROR_BY_ID = '[Error] REMOVE ERROR BY ID';
export const CLEAR_ALL_ERRORS = '[Error] CLEAR ALL ERRORS';

export abstract class Fail implements Action {
  public payload: Error;
  readonly isFailAction = true;
  abstract type: string;
  constructor(input: Error | ErrorOptions | String) {
    if (input instanceof Error) {
      this.payload = input;
    } else if (typeof input === 'string') {
      this.payload = new Error({ message: input });
    } else {
      // action.payload is ErrorOptions
      this.payload = new Error(input as ErrorOptions);
    }
  }
}

export class Add extends Fail {
  readonly type = ADD_ERROR;
}

export class Remove implements Action {
  readonly type = REMOVE_ERROR;
  constructor(public payload: Error) {}
}

export class RemoveById implements Action {
  readonly type = REMOVE_ERROR_BY_ID;
  constructor(public payload: number) {}
}

export class Clear implements Action {
  readonly type = CLEAR_ALL_ERRORS;
  constructor() {}
}

export type All = Add | Remove | RemoveById | Clear;
